import { ReviewCardIsCroppedContext } from '@contexts/review-card-is-cropped'
import { ContentType } from '@entries/content-types'
import ContentfulPlatformScore from '@entries/contentful-platform-score'
import NetreviewsReviewCard from '@entries/netreviews-review-card'
import TrustpilotReviewCard from '@entries/trustpilot-review-card'
import { usePlatformsScores } from '@hooks/use-platform-scores'
import { Entry } from '@resolvers/entry'
import { CustomersReviewsStructuredData } from '@sd/customers-reviews-data-structured'
import { Container } from '@ui/container'
import { Hyperlink } from '@ui/hyperlink'
import clsx from 'clsx'
import { graphql, useStaticQuery } from 'gatsby'
import React, { type FC } from 'react'

const BlockFourCustomersReviews: FC = () => {
  const { reviews } = useStaticQuery<Queries.BlockFourCustomersReviewsQuery>(
    graphql`
      query BlockFourCustomersReviews {
        reviews: getBestCustomerReviews(limit: 4) {
          ...TrustpilotReviewCard
          ...NetreviewsReviewCard
        }
      }
    `
  )

  const platformsScores = usePlatformsScores()

  return (
    <Container className="mb-10">
      <CustomersReviewsStructuredData reviews={reviews} />
      <div className="flex flex-col gap-10">
        <div className="grid grid-cols-2 gap-10 laptop:grid-cols-4 laptopL:grid-cols-6">
          {platformsScores.map((score, index) => (
            <div
              key={score.platform}
              className={clsx(index === 0 && 'laptopL:col-start-2')}
            >
              <Entry
                content={score}
                mapping={{
                  [ContentType.ContentfulPlatformScore]:
                    ContentfulPlatformScore,
                }}
              />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 items-stretch justify-center gap-x-3 gap-y-8 laptop:grid-cols-2 laptop:gap-6 laptopL:grid-cols-4">
          <ReviewCardIsCroppedContext.Provider value={true}>
            {reviews.map((review) => (
              <Entry
                key={review.id}
                content={review}
                mapping={{
                  [ContentType.NetreviewsReview]: NetreviewsReviewCard,
                  [ContentType.TrustpilotReview]: TrustpilotReviewCard,
                }}
              />
            ))}
          </ReviewCardIsCroppedContext.Provider>
        </div>
        <Hyperlink href="/avis-clients">Lire tous les avis</Hyperlink>
      </div>
    </Container>
  )
}

export default BlockFourCustomersReviews
